import { Head } from '@inertiajs/react'

import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import type { Breadcrumb } from '@/types/shared'
import { Form, type ParticipantOption, type PracticeMatchFormValues } from './components/Form'

type Props = {
  practiceMatch: PracticeMatchFormValues
  options: { teams: ParticipantOption[]; schools: ParticipantOption[] }
  breadcrumbs: Breadcrumb[]
}

export default function Edit({ practiceMatch, options, breadcrumbs }: Props) {
  return (
    <AppShell>
      <Head title="練習試合の編集" />
      <PageHeader
        title="練習試合の編集"
        description="登録済みの練習試合の内容を更新します。"
        breadcrumbs={breadcrumbs}
      />
      <Form values={practiceMatch} teams={options.teams} schools={options.schools} mode="edit" />
    </AppShell>
  )
}
